import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/standard/standard-bg.png'
import _imports_1 from '@/assets/img/standard/standard-objective.png'
import _imports_2 from '@/assets/img/standard/standard-range.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-33e3f858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description-img" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2,
  alt: ""
}

import Description from './description-text.vue'
import { DescriptionProps } from './description.ts'




export default /*#__PURE__*/_defineComponent({
  __name: 'description',
  props: {
    type: { default: 'bg' },
    direction: { default: 'left' },
    title: {},
    content: {},
    btnText: {},
    showbtn: { type: Boolean }
  },
  emits: ["detail"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit
const handleClick = () => {
  emit('detail')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["description", { reverse: _ctx.direction === 'right'}])
  }, [
    _createVNode(Description, {
      title: _ctx.title,
      content: _ctx.content,
      showbtn: _ctx.showbtn,
      onDetail: handleClick
    }, null, 8, ["title", "content", "showbtn"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.type === 'bg')
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.type === 'objective')
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.type === 'range')
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})